<template functional>
  <SocialImage
    title="TikTok"
    v-bind="data.attrs"
    :class="[data.class, data.staticClass]"
    channel="tiktok"
    v-on="listeners"
  />
</template>

<script>
import SocialImage from './SocialImage';

export default {
  name: 'TikTokImage',
  components: {
    SocialImage,
  },
};
</script>

